<script>
  export let size = "22";
</script>

<svg
  width={size}
  height={(Number(size) * 17.0189) / 20.7778}
  viewBox="0 0 20.7778 17.0189"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g>
    <path
      d="M0 6.36556C0 8.27333 1.02 10.0111 2.60667 11.1822C2.73889 11.2767 2.81444 11.4278 2.81444 11.5978C2.81444 11.6544 2.79556 11.7111 2.79556 11.7678C2.66333 12.24 2.47444 13.0144 2.45556 13.0522C2.43667 13.1089 2.41778 13.1844 2.41778 13.2411C2.41778 13.3733 2.53111 13.4867 2.66333 13.4867C2.72 13.4867 2.75778 13.4678 2.81444 13.43L4.45778 12.4667C4.59 12.3911 4.72222 12.3533 4.85444 12.3533C4.93 12.3533 5.00556 12.3722 5.08111 12.3911C5.85556 12.6178 6.68667 12.7311 7.53667 12.7311C11.6922 12.7311 15.0544 9.87889 15.0544 6.36556C15.0544 2.85222 11.6733 0 7.51778 0C3.36222 0 0 2.85222 0 6.36556Z"
      fill="white"
    />
    <path
      d="M0 6.36556C0 8.27333 1.02 10.0111 2.60667 11.1822C2.73889 11.2767 2.81444 11.4278 2.81444 11.5978C2.81444 11.6544 2.79556 11.7111 2.79556 11.7678C2.66333 12.24 2.47444 13.0144 2.45556 13.0522C2.43667 13.1089 2.41778 13.1844 2.41778 13.2411C2.41778 13.3733 2.53111 13.4867 2.66333 13.4867C2.72 13.4867 2.75778 13.4678 2.81444 13.43L4.45778 12.4667C4.59 12.3911 4.72222 12.3533 4.85444 12.3533C4.93 12.3533 5.00556 12.3722 5.08111 12.3911C5.85556 12.6178 6.68667 12.7311 7.53667 12.7311C11.6922 12.7311 15.0544 9.87889 15.0544 6.36556C15.0544 2.85222 11.6733 0 7.51778 0C3.36222 0 0 2.85222 0 6.36556Z"
      fill="url(#wechat_paint0)"
    />
    <path
      d="M8.23553 11.0878C8.23553 14.0156 11.05 16.3767 14.5066 16.3767C15.2244 16.3767 15.9044 16.2822 16.5466 16.0933C16.6033 16.0744 16.66 16.0744 16.7355 16.0744C16.8489 16.0744 16.9622 16.1122 17.0755 16.1689L18.4544 16.9811C18.4922 17 18.53 17.0189 18.5678 17.0189C18.6811 17.0189 18.7755 16.9244 18.7755 16.8111C18.7755 16.7544 18.7566 16.6978 18.7378 16.66C18.7378 16.6222 18.5678 15.9989 18.4544 15.5833C18.4355 15.5456 18.4355 15.4889 18.4355 15.4511C18.4355 15.3 18.5111 15.1867 18.6055 15.1111C19.9278 14.1478 20.7778 12.7122 20.7778 11.1067C20.7778 8.17889 17.9633 5.81778 14.5066 5.81778C11.05 5.78 8.23553 8.16 8.23553 11.0878Z"
      fill="url(#wechat_paint1)"
    />
    <g>
      <path
        d="M15.8293 9.46333C15.8293 9.93556 16.2071 10.3133 16.6604 10.3133C17.1327 10.3133 17.4915 9.93556 17.4915 9.46333C17.4915 8.99111 17.1138 8.61333 16.6604 8.61333C16.2071 8.61333 15.8293 8.99111 15.8293 9.46333Z"
        fill="#919191"
      />
      <path
        d="M11.6361 9.46333C11.6361 9.93555 12.0139 10.3133 12.4673 10.3133C12.9395 10.3133 13.2984 9.93555 13.2984 9.46333C13.2984 8.99111 12.9206 8.61333 12.4673 8.61333C12.0139 8.61333 11.6361 8.99111 11.6361 9.46333Z"
        fill="#919191"
      />
    </g>
    <g>
      <path
        d="M6.00648 4.30667C6.00648 4.87333 5.55315 5.32667 5.00537 5.32667C4.4576 5.32667 4.00426 4.87333 4.00426 4.30667C4.00426 3.74 4.4576 3.28667 5.00537 3.28667C5.57204 3.28667 6.00648 3.75889 6.00648 4.30667Z"
        fill="#168743"
      />
      <path
        d="M11.0492 4.30667C11.0492 4.87333 10.5959 5.32667 10.0481 5.32667C9.50031 5.32667 9.04697 4.87333 9.04697 4.30667C9.04697 3.74 9.50031 3.28667 10.0481 3.28667C10.5959 3.28667 11.0492 3.75889 11.0492 4.30667Z"
        fill="#168743"
      />
    </g>
  </g>
  <defs>
    <linearGradient
      id="wechat_paint0"
      x1="7.52516"
      y1="13.4672"
      x2="7.52516"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.0601963" stop-color="#05CD66" />
      <stop offset="0.2202" stop-color="#0ED169" />
      <stop offset="0.4805" stop-color="#26DB6F" />
      <stop offset="0.8069" stop-color="#4DEB7A" />
      <stop offset="0.9517" stop-color="#61F380" />
    </linearGradient>
    <linearGradient
      id="wechat_paint1"
      x1="14.511"
      y1="17"
      x2="14.511"
      y2="5.78563"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.0809942" stop-color="#D9D9D9" />
      <stop offset="1" stop-color="#F0F0F0" />
    </linearGradient>
  </defs>
</svg>
